import moment from 'moment';

import PlusLogo from 'src/images/login/plus_logo_small.png'
import DnaLogo from 'src/images/login/dna_logo_small.png'
import OveyLogo from 'src/images/login/oveyLogo.png'

import HeruiLogo from 'src/images/login/heruiLogo.png'


/*
    oem 用法
    根据 url 匹配 host
    LoginView 登录页面
    Logo 登录之后的左上角Logo
    Theme 主题颜色Class
    order 定制化oem 
    ignoreAdxs 隐藏的adx
*/

export const OEMLIST = [
    {
        url: ['plus.yoyi.com.cn', '192.168.5.94:3001', '10.0.3.62'],
        title: 'plus',
        Logo: PlusLogo,
        favicon: './favicon.ico',
        needMapping: false,
        footerText: 'Copyright  2007-2025 YOYI Inc. All rights reserved.'
    },
    {
        url: ['dna.yoyi.com.cn', '192.168.5.94:9070', 'localhost:3001'],
        title: 'DNA',
        Logo: PlusLogo,
        favicon: './favicon.ico',
        needMapping: false,
        footerText: `Copyright  2007-${moment().year()} YOYI Inc. All rights reserved.`
    },
    {
        url: ['dsp.avc-ott.com'],
        title: '聚壹科技',
        Logo: OveyLogo,
        favicon: './favicon/juyisharing.ico',
        needMapping: false,
        footerText: 'Copyright  2007-2019 JUYISHARING Inc. All rights reserved.'
    },
    {
        url: ['hezhipp.com'],
        title: '合睿U+',
        Logo: HeruiLogo,
        favicon: './favicon/hezhipp.ico',
        needMapping: false,
        footerText: '上海有睿营销策划有限公司 版权所有.'
    }
]